<!--校园安全（视频/政策）-->
<template>
    <div class="studio_nav_content">
        <!--视频-->
        <school-safe-video v-if="activeTab==='video'"
                           @change-tab="$emit('change-tab', $event)"/>
        <!--政策-->
        <school-safe-policy v-if="activeTab==='policy'"
                            :course-mode="courseMode"
                            @change-mode="changeModel"
                            @change-tab="$emit('change-tab', $event)"/>
    </div>
</template>

<script>
import schoolSafeVideo from "@/components/resourceCentre/schoolSafeVideo.vue";
import schoolSafePolicy from "@/components/resourceCentre/schoolSafePolicy.vue";

export default {
    name:'schoolSafeResource',
    components:{schoolSafeVideo, schoolSafePolicy},
    props:{
        courseMode:{
            type: String,
            default:'page'
        },
        /*当前分类：video-视频 policy-政策*/
        activeTab:{
            type: String,
            default:'video'
        },
    },
    methods: {
        changeModel(item){
            this.$emit('change-mode', item);
        },
    }
}

</script>

<style lang="scss" scoped>
.studio_nav_content{
    width: 100%;
    height: auto;
}
</style>
